import Carousel from 'react-multi-carousel'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { grid } from '@ocean/configs'

const { MOBILE_GRID_GUTTER, DESKTOP_GRID_GUTTER } = grid

export const CarouselWrapper = styled.div`
  ${media.sm`
    overflow: hidden;
    margin-left: -${MOBILE_GRID_GUTTER * 2}px;
    margin-right: -${MOBILE_GRID_GUTTER * 2}px;
    padding-left: ${MOBILE_GRID_GUTTER * 2}px;
    padding-right: ${MOBILE_GRID_GUTTER * 2}px;
  `}
`

export const CarouselContainer = styled(Carousel)`
  overflow: visible !important;
  margin-left: -${MOBILE_GRID_GUTTER / 2}px;
  margin-right: -${MOBILE_GRID_GUTTER / 2}px;

  ${media.sm`
    padding-bottom: 30px;
  `}

  ${media.md`
    margin-left: -${DESKTOP_GRID_GUTTER / 2}px;
    margin-right: -${DESKTOP_GRID_GUTTER / 2}px;
  `}

  .grid-carousel-item {
    padding-left: ${MOBILE_GRID_GUTTER / 2}px;
    padding-right: ${MOBILE_GRID_GUTTER / 2}px;

    ${media.md`
      padding-left: ${DESKTOP_GRID_GUTTER / 2}px;
      padding-right: ${DESKTOP_GRID_GUTTER / 2}px;
    `}
  }

  div[data-selector='TrackHorizontal'] {
    ${media.sm`
      left: ${MOBILE_GRID_GUTTER / 2}px !important;
      right: ${MOBILE_GRID_GUTTER / 2}px !important;
    `}

    ${media.md`
      left: ${DESKTOP_GRID_GUTTER / 2}px !important;
      right: ${DESKTOP_GRID_GUTTER / 2}px !important;
    `}
  }
`
